import React, { FC } from 'react'
import { AddPartitionProps as Props } from './types'
import { NewButton, Input, Title } from 'prace-common-components'
import { useGetPartitionTypesQuery } from 'store/api/partitions'
import { $Grid } from './styles'

export const AddPartition: FC<Props> = ({ partition, onBackClick, handleUpdatePartition }) => {
  const { data: partitionTypes = [] } = useGetPartitionTypesQuery()

  const handleUpdate = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const data = new FormData(e.target as HTMLFormElement)
    const values = Object.fromEntries(data.entries())
    const { name, type } = values
    if(name) handleUpdatePartition({ ...partition, name: name as string, type: type as string })
  }

  return (
    <form onSubmit={handleUpdate}>
      <$Grid container>
        <Title
          hasBack
          onBackClick={onBackClick}
        >
          {partition.name ? 'Edit Partition' : 'Add Partition'}
        </Title>
        <Input
          type='text'
          title='Partition Name'
          name='name'
          defaultValue={partition.name}
          hideItalic
        />
        {/* ponytail: native datalist — pick an existing type or type a new one, no combobox state.
            The API folds a case-insensitive match onto the existing spelling.
            withAutocomplete is required: without it Input sets autocomplete='new-password', which makes
            Chrome hand the field to the password manager and drop the datalist popup (arrow, no list). */}
        <Input
          withAutocomplete
          type='text'
          title='Partition Type'
          name='type'
          defaultValue={partition.type}
          inputProps={{ list: 'partition-types' }}
          hideItalic
        />
        <datalist id='partition-types'>
          {partitionTypes.map((type) => <option key={type} value={type} />)}
        </datalist>
        <NewButton type='submit'>{partition.name ? 'Edit Partition' : 'Add Partition'}</NewButton>
      </$Grid>
    </form>
  )
}
